import type { ActiveMind } from '../services/api';

export function PresencePortrait({ mind = 'hannah', name = 'Hannah' }: { mind?: ActiveMind; name?: string }) {
  return (
    <section className="presence-portrait" aria-label={`${name} portrait`}>
      <div className="portrait-title"><p className="section-index">AN EVOLVING MIND</p><h2>{name}<span>.</span></h2></div>
      <img className="portrait-image" src={mind === 'hannah' ? '/hannah-glass.webp' : '/amanda-avatar.png'}
        alt={mind === 'hannah' ? 'Hannah’s portrait seen through fractured, light-catching glass' : 'Amanda’s portrait'} />
      <div className="portrait-caption"><span>{mind === 'hannah' ? 'A study in continuity' : 'A distinct perspective'}</span><span aria-hidden="true">↗</span></div>
    </section>
  );
}
